import React from "react";
import styles from "./PlanComparaisonModal.module.css";
import i18n from "../../Services/i18n";
import { ro } from "date-fns/locale";

const PlanComparisonModal = ({ onClose }) => {
  const data = [
    { label: "maxClient", basic: "5", pro: "250" },
    { label: "maxHorses", basic: "10", pro: "500" },
    { label: "maxServiceOccurences", basic: "100", pro: "-1" },
    { label: "maxServiceOccurencesByDay", basic: "3", pro: "50" },
    { label: "maxHorsesByClient", basic: "3", pro: "50" },
    { label: "maxServicesByHorse", basic: "100", pro: "500" },
    { label: "maxServicesByClient", basic: "100", pro: "500" },
    { label: "maxUserServices", basic: "3", pro: "50" },
    { label: "maxNoteByClient", basic: "1", pro: "20" },
    { label: "maxNoteByHorse", basic: "3", pro: "25" },
    { label: "maxNoteByService", basic: "1", pro: "20" },
    { label: "maxMediaByClient", basic: "1", pro: "25" },
    { label: "maxMediaByHorse", basic: "1", pro: "25" },
    { label: "maxMediaByService", basic: "1", pro: "25" },
    { label: "maxBodyMapByClient", basic: false, pro: "10" },
    { label: "maxBodyMapByHorse", basic: "1", pro: "20" },
    { label: "maxBodyMapByService", basic: false, pro: "10" },
    { label: "canUploadDocument", basic: false, pro: true },
    { label: "canUploadVideo", basic: false, pro: true },
    { label: "canGenerateReport", basic: false, pro: true },
  ];
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>{i18n.t("PlanComparaisonHeader.Title")}</h2>
          <button onClick={onClose} className={styles.closeButton}>
            ×
          </button>
        </div>
        <div className={styles.tableWrapper}>
          <table className={styles.comparisonTable}>
            <thead>
              <tr className={styles.stickyHeader}>
                <th>{i18n.t("PlanComparaisonHeader.Elements")}</th>
                <th>{i18n.t("PlanComparaisonHeader.Basic")}</th>
                <th className={styles.proColHeader}>{i18n.t("PlanComparaisonHeader.Pro")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={i}>
                  <td>{i18n.t("PlanComparaison.Privileges." + row.label)}</td>
                  <td>{renderValue(row.basic)}</td>
                  <td className={styles.proCol}>{renderValue(row.pro, row.label)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

function renderValue(value, label) {
  /* label used to shortcut data presentation (DT) */
  if (value === "-1") return "–";
  if (label === "canUploadVideo") return <span className={styles.check}>⚠️</span>;
  if (typeof value === "boolean") {
    return value ? (
      <span className={styles.check}>✅</span>
    ) : (
      <span className={styles.cross}>❌</span>
    );
  }

  return value;
}

export default PlanComparisonModal;
